import { render, staticRenderFns } from "./BreaksTable.vue?vue&type=template&id=010d848c&"
import script from "./BreaksTable.vue?vue&type=script&lang=js&"
export * from "./BreaksTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports